export default "__VITE_ASSET__Br964zVK__"